import { cn } from "@/lib/utils";

export function PageHeader({ title, description, children, testid }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8" data-testid={testid}>
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight">{title}</h1>
        {description && <p className="text-sm text-muted-foreground mt-1.5 max-w-2xl">{description}</p>}
      </div>
      {children && <div className="flex items-center gap-2 shrink-0">{children}</div>}
    </div>
  );
}

export function StatCard({ label, value, hint, accent, icon: Icon, testid }) {
  return (
    <div className="bg-card border border-border rounded-md p-5" data-testid={testid}>
      <div className="flex items-start justify-between">
        <span className="label-caps">{label}</span>
        {Icon && <Icon className={cn("w-4 h-4", accent ? "text-[#FF4500]" : "text-muted-foreground")} />}
      </div>
      <div className={cn("font-display text-2xl font-semibold mt-3 tabular", accent && "text-[#FF4500]")}>{value}</div>
      {hint && <div className="text-xs text-muted-foreground mt-1">{hint}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description, children, testid }) {
  return (
    <div className="border border-dashed border-border rounded-md py-16 flex flex-col items-center text-center px-6" data-testid={testid}>
      {Icon && <Icon className="w-8 h-8 text-muted-foreground mb-4" />}
      <div className="font-display font-medium">{title}</div>
      {description && <p className="text-sm text-muted-foreground mt-1 max-w-sm">{description}</p>}
      {children && <div className="mt-5">{children}</div>}
    </div>
  );
}

export function StatusPill({ active, activeLabel = "Active", inactiveLabel = "Inactive" }) {
  return (
    <span className={cn("inline-flex items-center gap-1.5 text-xs font-medium px-2 py-0.5 rounded-full",
      active ? "bg-green-50 text-green-700" : "bg-secondary text-muted-foreground")}>
      <span className={cn("w-1.5 h-1.5 rounded-full", active ? "bg-green-600" : "bg-muted-foreground")} />
      {active ? activeLabel : inactiveLabel}
    </span>
  );
}

export function Loading() {
  return (
    <div className="py-24 flex justify-center">
      <div className="w-6 h-6 border-2 border-foreground/20 border-t-foreground rounded-full animate-spin" />
    </div>
  );
}
